export class Notification {
    constructor(public type: string = '',
                public message: string = '',
                public description: string = '',
                public includePremessage: boolean = true
                ) {
    }
}